/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Settings_Fields_Clarity_Project_IdInputs */

const en_admin_settings_fields_clarity_project_id = /** @type {(inputs: Admin_Settings_Fields_Clarity_Project_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Project ID`)
};

/**
* | output |
* | --- |
* | "Project ID" |
*
* @param {Admin_Settings_Fields_Clarity_Project_IdInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_settings_fields_clarity_project_id = /** @type {((inputs?: Admin_Settings_Fields_Clarity_Project_IdInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Settings_Fields_Clarity_Project_IdInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_settings_fields_clarity_project_id(inputs)
});
export { admin_settings_fields_clarity_project_id as "admin.settings.fields.clarity_project_id" }